import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { Stack } from '@mui/material';

import { NavItem } from '.';
import { INavItem } from 'models';

interface NavListProps {
  display?: Record<string, unknown>;
  direction?: string;
  spacing?: number;
  align?: string;
  navItems?: Array<INavItem>;
  navItemStyle?: any;
  activeLink?: string;
  onNavItem?: Function;
}

export const NavList: React.FC<NavListProps> = (props) => {
  const navigate = useNavigate();
  const {
    display = {},
    direction = 'row',
    spacing = props.direction === 'column' ? 2 : 4,
    align = props.direction === 'column' ? 'left' : 'center',
    navItems = [],
    navItemStyle = {},
    activeLink = null,
    onNavItem = () => {},
  } = props;

  return (
    <Stack display={display as any} direction={direction as any} spacing={spacing}>
      {navItems.map((navItem) => (
        <NavItem
          key={navItem.id}
          icon={navItem.icon}
          label={navItem.label}
          variant={navItem.variant}
          align={align}
          active={navItem.link === activeLink}
          style={{ ...navItemStyle, ...navItem.style }}
          onClick={
            navItem.link
              ? () => {
                  if (navItem.link?.includes('http') || navItem.link?.includes('https')) {
                    window.open(navItem.link as string, '_blank');
                  } else {
                    navigate(navItem.link || '');
                    onNavItem();
                  }
                }
              : () => {
                  onNavItem();
                }
          }
        />
      ))}
    </Stack>
  );
};
